import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../environments/environment";
import { ApiUrlConstant } from "../../../constants/api-url.constant";
import { GenericHttpService } from "../../../services/generic-http.service";
import { Observable } from "rxjs";
import { CommonService } from "./../../../services/common.service";
import { GenericUtils } from "./../../../utilities/generic-utils";

@Injectable({
  providedIn: 'root'
})
export class DataService {
  apiUrl = environment.gateWayHost;
  constructor(
    public generic: GenericHttpService,
    private urlConstant: ApiUrlConstant,
    private utils: GenericUtils,
    private commonService: CommonService
  ) { }

  getData(param, query): Observable<any> {
    param.api.includes('json') ? this.apiUrl = environment.baseUrl : this.apiUrl = environment.gateWayHost;
    const option = {
      method: "GET",
      url: `${this.apiUrl}${param.api}`,
      query: query
    };
    const functionToExecute = param['functionToCall'] ? this[param['functionToCall']].bind(this) : this.generic.responseData;
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(functionToExecute)
    );
  }


  processOutboundWorstAffectedWarehouse(data) {
    //debugger;
    if (!data.data.length) return null;
    const originalData = data.data[0][Object.keys(data.data[0])[0]], tempArray = [];
    originalData.map(ele => {
      if (ele['origin_code'] !== 'Total' && ele['sla'] <= 98) {
        ele['warehouse'] = `${ele['origin_client_name']} / ${ele['origin_code']} `;
        tempArray.push(ele);
      }
    });

    return { data: tempArray.reverse() };

  }
  // processOutboundBestPerformingWarehouse(data) {
  //   if (!data.data.length) return null;
  //   const originalData = data.data[0][Object.keys(data.data[0])[0]], tempArray = [];
  //   originalData.map(ele => {
  //     if (ele['origin_code'] !== 'Total') {
  //       tempArray.push(ele);
  //     }
  //   });

  //   return { data: tempArray.reverse() };

  // }

  processInboundMostAffectedProduct(data) {
    if (!data.data.length) return null;
    const originalData = data.data[0][Object.keys(data.data[0])[0]], tempArray = [];
    originalData.map(ele => {
      if (ele['client_product_category'] !== 'Total' && ele['sla'] <= 98) {
        tempArray.push(ele);
      }
    });
    return { data: tempArray };

  }

  processInboundWorstAffectedWarehouse(data) {
    if (!data.data.length) return null;
    const originalData = data.data[0][Object.keys(data.data[0])[0]], tempArray = [];
    originalData.map(ele => {
      if (ele['destination_code'] !== 'Total' && ele['sla'] <= 98) {
        ele['warehouse'] = `${ele['destination_client_name']} / ${ele['destination_code']} `;
        tempArray.push(ele);
      }
    });

    return { data: tempArray.reverse() };

  }


  processPercentage(apiData) {
    if (apiData.data && apiData.data.length && Object.keys(apiData.data[0]).length &&
      apiData.data[0].InventoryListingStorageGroup && apiData.data[0].InventoryListingStorageGroup.length &&
      apiData.data[0].InventoryListingStorageGroupTotal && apiData.data[0].InventoryListingStorageGroupTotal.length) {
      const total = apiData.data[0].InventoryListingStorageGroupTotal[0].total_quantity;
      apiData.data[0].InventoryListingStorageGroup.forEach(ele => {
        ele['percentage'] = (((+ele['total_quantity']) / total) * 100).toFixed(2) || 0;
        ele['total_quantity'] = this.commonService.numberWithCommas(ele['total_quantity']);
        ele['total_value'] = this.utils.amountIndianUnitRoundOff(ele['total_value']);
      });
      return { data: apiData.data[0].InventoryListingStorageGroup.sort((a, b) => b.percentage - a.percentage) };
    } else {
      return { data: [] };
    }

  }

  processMostAffectedOd(data: any) {
    const originaldata = data.data[0][Object.keys(data.data[0])[0]];
    if (originaldata && originaldata.length) {

      originaldata.forEach(ele => {
        ele.origin_city_destination_city = ele.destination_city && ele.origin_city ?
          `${ele.origin_city}-${ele.destination_city}` : (ele.origin_city || ele.destination_city);
        ele.sla = ele.sla;
      });

      originaldata.sort((a, b) => a.sla - b.sla);

      return { data: originaldata };
    } else {
      return { data: [] };
    }
  }
}
